export const iconFontAwesomeMaritimeWater = (
	<i className="fa-solid fa-water"></i>
);
